import api from '../../../api/parametres/_accessibilite'

const state = () => ({
    liste_access_checker_type_consultation: [],
    liste_access_checker_type_examen: [],

    liste_roles: [],
})

// getters
const getters = {
    liste_access_checker_type_consultation: (state) => {
        return state.liste_access_checker_type_consultation
    },

    liste_access_checker_type_examen: (state) => {
        return state.liste_access_checker_type_examen
    },

    liste_roles: (state) => {
        return state.liste_roles
    },
}

// mutations
const mutations = {
    SET_ACCES_CHECKER_TO_TYPE_CONSULTATION(state, access) {
        state.liste_access_checker_type_consultation = access;
    },

    SET_ACCES_CHECKER_TO_TYPE_EXAMEN(state, access) {
        state.liste_access_checker_type_examen = access;
    },

    SET_LISTE_ROLES(state, roles) {
        state.liste_roles = roles;
    },
}

// actions
const actions = {
    saveConsultationAccessibilite({dispatch}, data) {
        return new Promise((resolve, reject) => {
            api.saveConsultationAccessibilite(data).then(
                response => {
                    dispatch
                    resolve(response)
                }, error => {
                    reject(error)
                }
            )
        })
    },

    getAccessCheckerToTypePrestation({commit}, data) {
        return new Promise((resolve, reject) => {
            api.getAccessCheckerToTypePrestation(data).then(
                response => {
                    resolve(response)

                    if (data.data_type == 'type_consultation') {
                        commit('SET_ACCES_CHECKER_TO_TYPE_CONSULTATION', response)
                    } else {
                        commit('SET_ACCES_CHECKER_TO_TYPE_EXAMEN', response)
                    }
                }, error => {
                    reject(error)
                }
            )
        })
    },

    getListeRoles({commit}) {
        return new Promise((resolve, reject) => {
            api.getListeRoles().then(
                response => {
                    resolve(response)
                    commit('SET_LISTE_ROLES', response)
                }, error => {
                    reject(error)
                }
            )
        })
    },

    saveUser({dispatch}, data){
        return new Promise((resolve,reject) => {
            api.saveUser(data).then(
                response => {
                    dispatch
                    resolve(response)  
                }, error=> {
                    reject(error)
                }
            )
        })
    },

    deleteUser({dispatch}, data){
        return new Promise((resolve,reject) => {
            api.deleteUser(data).then(
                response => {
                    dispatch
                    resolve(response)  
                }, error=> {
                    reject(error)
                }
            )
        })
    },

    updateUserProfil({dispatch}, data){
        return new Promise((resolve,reject) => {
            api.updateUserProfil(data).then(
                response => {
                    dispatch
                    resolve(response)  
                }, error=> {
                    reject(error)
                }
            )
        })
    },

    updateUserPassword({dispatch}, data){
        return new Promise((resolve,reject) => {
            api.updateUserPassword(data).then(
                response => {
                    dispatch
                    resolve(response)  
                }, error=> {
                    reject(error)
                }
            )
        })
    },
}

export default {
    state,
    getters,
    mutations,
    actions
}